import React, { useEffect, useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
  CircularProgress,
  Divider,
} from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import classNames from 'classnames'
import mapValues from 'lodash/mapValues'
import CustomAlert from '../../CustomAlert'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { dateFormatter, sleep } from '../../Models/CommonFunc'
import { Helmet } from 'react-helmet'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { createSalesBillsDocument } from '../../../Backend/firebase/sales-bills'
import { getProductAndSalesDocumentWithUserId } from '../../../Backend/firebase/product-and-sales'
import { getClientDocumentWithUserId } from '../../../Backend/firebase/party'
import { checkIsStockOfProductExistsOrNot, createProductStockDocument, updateProductStockDocument } from '../../../Backend/firebase/product-stock'
import db from '../../../Backend/firebase/firebase'
const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function CreateSalesBills() {
  const { register, handleSubmit, errors, reset, setValue } = useForm()
  const classes = useStyles()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [InvoiceDate, setInvoiceDate] = useState(dateFormatter(new Date()))
  const [previewState, setPreviewState] = useState({})
  const [isPreview, setIsPreview] = useState(false)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [IsPartyManully, setIsPartyManully] = useState(false)
  const { userData } = CheckUserProvider()
  const [PartyEntry, setPartyEntry] = useState([])
  const [partyItems, setPartyItems] = useState([])
  const [ProductEntry, setProductEntry] = useState([])
  const [productItems, setProductItems] = useState([])
  const [searchItem, setSearchItem] = useState([])
  const [BillType, setBillType] = useState('Select Option');
  const [ProductQuantity, setProductQuantity] = useState(0)
  var batch = db.batch()

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  useEffect(async () => {
    if (userData) {
      try {
        const getProductsAndSales = await getProductAndSalesDocumentWithUserId(
          userData.uid,
        )
        setProductItems(getProductsAndSales)
      } catch (error) {
        console.log('Error Occur in Get Products And Sales', error)
      }
    }
  }, [userData])

  useEffect(async () => {
    if (userData) {
      try {
        const getPartyDetails = await getClientDocumentWithUserId(userData.uid)
        setPartyItems(getPartyDetails)
      } catch (error) {
        console.log('Error Occur in Get Products And Sales', error)
      }
    }
  }, [userData])

  const onSubmit = async (data) => {
    console.log('on Tap Submit')
  }

  const generateString = () => {
    let result = ' ';
    const charactersLength = characters.length;
    for ( let i = 0; i < 4; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result.toUpperCase();
  }

  const handlePreviewSubmit = () => {
    handleSubmit(async (data) => {
      var newSalesBills = {}
      newSalesBills.userId = userData.uid
      newSalesBills.BillType = data.BillType
      newSalesBills.PaymentReceived = data.PaymentReceived
      newSalesBills.PartyName = data.PartyName
      newSalesBills.Address = data.Address
      newSalesBills.MobileNumber = data.MobileNumber
      newSalesBills.Email = data.Email
      newSalesBills.GSTNo = data.GSTNo
      newSalesBills.DrugLicense = data.DrugLicense
      newSalesBills.SalesPersonName = data.SalesPersonName
      newSalesBills.InvoiceNo = data.InvoiceNo
      newSalesBills.InvoiceDate = InvoiceDate
      newSalesBills.ProductEntry = ProductEntry
      newSalesBills.PartyEntry = PartyEntry
      setPreviewState(newSalesBills)
      setIsPreview(true)
    })()
  }

  const handleSaveSubmit = () => {
    handleSubmit(async (data) => {
      setIsLoading(true)

      var newSalesBills = {}
      newSalesBills.userId = userData.uid;
      newSalesBills.BillType = previewState.BillType;
      newSalesBills.PaymentReceived = previewState.PaymentReceived;
      newSalesBills.PartyName = previewState.PartyName;
      newSalesBills.Address = previewState.Address;
      newSalesBills.MobileNumber = previewState.MobileNumber;
      newSalesBills.Email = previewState.Email;
      newSalesBills.GSTNo = previewState.GSTNo;
      newSalesBills.DrugLicense = previewState.DrugLicense;
      newSalesBills.SalesPersonName = previewState.SalesPersonName;
      newSalesBills.InvoiceNo = `${generateString()}#_${previewState.InvoiceNo}`;
      newSalesBills.InvoiceDate = InvoiceDate;
      newSalesBills.ProductEntry = (previewState.ProductEntry && previewState.ProductEntry.length > 0) ? previewState.ProductEntry.map((item)=> {return {...item.Product, ProductOrderQuantity: item.ProductQuantity}}) : [];
      newSalesBills.PartyEntry = PartyEntry;
      newSalesBills.GSTValue = calculateGSTAmount();
      newSalesBills.GrossValue = calculateGrossAmount();
      newSalesBills.DiscountAmount = calculateDiscountAmount();
      newSalesBills.TotalAmount = calculateTotalAmount();
      try {
        var salesBills = createSalesBillsDocument(newSalesBills)
        if (salesBills) {
          if(previewState.ProductEntry && previewState.ProductEntry.length > 0) {
            let stockJson = previewState.ProductEntry.map(async (obj) => {
              var checkIsProductStockExists = await checkIsStockOfProductExistsOrNot(obj.Product._id)
              if (checkIsProductStockExists.length > 0) {
                var updateStocks = {}
                updateStocks.ProductID = obj.Product._id;
                updateStocks.TotalStock = checkIsProductStockExists[0].TotalStock - obj.ProductQuantity;
                return updateStocks;
              }
            });
            try {
              Promise.all(stockJson).then(async (results) => {
                await results.map(async (doc)=> {
                  const collectionRef = await db.collection('ProductStock').doc(doc.ProductID);
                  batch.update(collectionRef, doc);
                });
                batch.commit().then(() => {
                  console.error("BATCH COMMIT SUCCESS => ");
                }).catch((error)=> {
                  console.error("BATCH COMMIT ERROR => ",error);
                });
              }).catch(function(error) {
                console.error("TRY Catch ERROR => ",error);
              });
            } catch (error) {
              console.error("CATCH ERROR => ",error);
            }
          } else {
            console.log('ELSE PRODUCT ENTRY ERROR');
          }
          setNotificationMessage('Sales Record Added successfully.')
          setOpenNotify(true)
          setAlertType('success')
          reset()
          setIsLoading(false)
          setTimeout(routeToPages, 2000)
        } else {
          setNotificationMessage(
            'Something went wrong, Please try again later!!',
          )
          setOpenNotify(true)
          setAlertType('error')
          setIsLoading(false)
          history.push('/retailer/create-sales-bills')
        }
      } catch (error) {
        console.error(error)
        setNotificationMessage('Something went wrong, Please try again later!!')
        setOpenNotify(true)
        setAlertType('error')
        setIsLoading(false)
        history.push('/retailer/create-sales-bills')
      }
    })()
  }

  const editPreview = () => {
    setIsPreview(false)
    setTimeout(() => {
      mapValues(previewState, (value, key) => setValue(key, value))
    })
  }

  const routeToPages = () => {
    history.push('/retailer/sales-history')
  }

  const handleInvoiceDateChange = (e) => {
    setInvoiceDate(dateFormatter(e.target.value))
  }

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    console.log('handleOnSearch', string, results)
  }

  const handleOnHover = (result) => {
    // the item hovered
    console.log('handleOnHover', result)
  }

  const onTapAddProductButton = () => {
    // the item selected
    setProductEntry([
      ...ProductEntry,
      { ...searchItem, Product: searchItem?.ProductEntry[0], ProductQuantity: ProductQuantity },
    ])
  }

  const handleOnSelect = (item) => {
    // the item selected
    setSearchItem(item)
  }

  const handleOnSelectParty = (item) => {
    // the item selected
    setPartyEntry([...PartyEntry, item])
    setTimeout(() => {
      mapValues(item, (value, key) => setValue(key, value))
    })
  }

  const handleOnFocus = () => {
    console.log('Focused')
  }

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          {item.ProductName}
        </span>
      </>
    )
  }

  const formatResultParty = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          {item.PartyName}
        </span>
      </>
    )
  }

  const onTapOfDeleteProduct = (index) => {
    if (ProductEntry.length !== 1) {
        const values = [...ProductEntry]
        values.splice(index, 1)
        setProductEntry(values)
    }
  }

  const calculateGrossAmount = () => {
    if(previewState && previewState?.ProductEntry && previewState?.ProductEntry?.length > 0) {
      return previewState?.ProductEntry.reduce((accumulator, object) => {
        return Number(accumulator) + Number(object?.SellingPriceAsPerPrimaryPack * object?.ProductQuantity)
      }, 0)
    } 
    return 0;
  }

  const calculateGSTAmount = () => {
    if(previewState && previewState?.ProductEntry && previewState?.ProductEntry?.length > 0 && BillType != "Without GST") {
      return previewState?.ProductEntry.reduce((accumulator, object) => {
        return Number(accumulator) + ((object?.GSTClass && object?.GSTClass != 'Nil') ? Number(((object?.SellingPriceAsPerPrimaryPack * object?.ProductQuantity) * object?.GSTClass / 100)) : 0)
      }, 0)
    } 
    return 0;
  }

  const calculateDiscountAmount = () => {
    if(previewState && previewState?.ProductEntry && previewState?.ProductEntry?.length > 0) {
      return previewState?.ProductEntry.reduce((accumulator, object) => {
        return Number(accumulator) + ((object?.Discount && object?.Discount > 0) ? Number(((object?.SellingPriceAsPerPrimaryPack * object?.ProductQuantity) * object?.Discount / 100)) : 0)
      }, 0)
    } 
    return 0;
  }

  const calculateTotalAmount = () => {
    if(previewState && previewState?.ProductEntry && previewState?.ProductEntry?.length > 0) {
      return calculateGrossAmount() + calculateGSTAmount() - calculateDiscountAmount()
    } 
    return 0;
  }

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Creating New Sales Bill page." />
          <title>Create New Sales Bill Record | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {!isPreview && (
                <>
                  <h5 className="mt-3">
                    Party Details: &nbsp;
                    {IsPartyManully ? (
                      <VisibilityOffIcon
                        onClick={() => {
                          setIsPartyManully(false)
                          setTimeout(() => {
                            mapValues(PartyEntry, (value, key) =>
                              setValue(key, value),
                            )
                          })
                        }}
                      />
                    ) : (
                      <VisibilityIcon
                        onClick={() => {
                          setIsPartyManully(true)
                          setTimeout(() => {
                            mapValues(PartyEntry, (value, key) =>
                              setValue(key, value),
                            )
                          })
                        }}
                      />
                    )}
                  </h5>
                  <div className="row mb-3">
                    <div className="col-md-6 mb-2">
                      <ReactSearchAutocomplete
                        items={partyItems}
                        placeholder="Search Party..."
                        fuseOptions={{ keys: ['PartyName'] }}
                        // necessary, otherwise the results will be blank
                        resultStringKeyName="PartyName"
                        onSearch={handleOnSearch}
                        onHover={handleOnHover}
                        onSelect={handleOnSelectParty}
                        onFocus={handleOnFocus}
                        autoFocus
                        formatResult={formatResultParty}
                        styling={{
                          borderRadius: '8px',
                        }}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <select
                        className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.BillType })} 
                        aria-label="Default select example"
                        name="BillType" ref={register({
                            required: 'Please select Bill Type!',
                            validate: {
                                defaultValue: value => value !== "Select Option" || 'Please select Bill Type!'
                            }
                        })} 
                        onChange={(event)=> setBillType(event.target.value)}
                        defaultValue="Select Bill Type" >
                        <option value={'With GST'}>{'With GST'}</option>
                        <option value={'Without GST'}>{'Without GST'}</option>
                      </select>
                    </div>
                    <div className="col-md-3 mb-2">
                      {/*  */}
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        placeholder="Payment Received"
                        name="PaymentReceived"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                  </div>
                  <div className={IsPartyManully ? "row PartyManully" : "row InactivePartyManully"}>
                    <div className="col-md-5 mb-2">
                      Name
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="PartyName"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-7 mb-2">
                      Address
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="Address"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      Contact No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="MobileNumber"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      Email Id
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="Email"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      GST No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="GSTNo"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      D/L No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="DrugLicense"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                  </div>
                  <h5 className="mt-3">Sales Details:</h5>
                  <div className="col-md-4 mb-2">
                    Sales Person Name
                    <input
                      type="text"
                      className={classNames(
                        'form-control registerEmp__textbox',
                      )}
                      name="SalesPersonName"
                      autoComplete="none"
                      ref={register()}
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    Invoice No
                    <input
                      type="text"
                      className={classNames(
                        'form-control registerEmp__textbox',
                      )}
                      name="InvoiceNo"
                      autoComplete="none"
                      ref={register()}
                    />
                  </div>
                  <div className="col-md-4 mb-2 mt-2">
                    Invoice Date
                    <DatePickerComponent
                      id="InvoiceDate"
                      name="InvoiceDate"
                      value={InvoiceDate}
                      cssclassName="e-outline"
                      onChange={(e) => handleInvoiceDateChange(e)}
                      ref={register()}
                    />
                  </div>
                  <h5 className="mt-3">Product Details:</h5>
                  <div className="row mb-3">
                    <div className="col-md-7 mb-2">
                      <ReactSearchAutocomplete
                        items={productItems}
                        placeholder="Search Product..."
                        fuseOptions={{ keys: ['ProductName'] }}
                        // necessary, otherwise the results will be blank
                        resultStringKeyName="ProductName"
                        onSearch={handleOnSearch}
                        onHover={handleOnHover}
                        onSelect={handleOnSelect}
                        onFocus={handleOnFocus}
                        autoFocus
                        formatResult={formatResult}
                        styling={{
                          borderRadius: '8px',
                        }}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      {/*  */}
                      <input
                        type="number"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        placeholder="Product Quantity"
                        name="ProductQuantity"
                        autoComplete="none"
                        onChange={(event) =>
                          setProductQuantity(event.target.value)
                        }
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-2 mb-2">
                      {/*  */}
                      <div className="addBox">
                        {/* <label className="login__textboxLabel jsm__textboxLabel">{} </label> */}
                        <Button
                          onClick={onTapAddProductButton}
                          variant="contained"
                          className="registerEmp__btnLogin jsmAdd"
                        >
                          {'Add'}
                        </Button>
                      </div>
                    </div>
                  </div>
                  {ProductEntry && ProductEntry.length > 0 && (
                    <table className="table">
                      <thead>
                        <td>S.No</td>
                        <td>Product</td>
                        <td>Quantity</td>
                        <td>Exp Date</td>
                        <td>HSN Code</td>
                        <td>Batch No</td>
                        <td>MRP</td>
                        <td>Selling MRP</td>
                        <td>S/F</td>
                        <td>CGST</td>
                        <td>SGST</td>
                        <td>GST Value</td>
                        <td>Gross Amount</td>
                        <td>Discount</td>
                        <td>Total Amount</td>
                        <td>Action</td>
                      </thead>
                      <tbody>
                        {ProductEntry.map((item, index) => {
                          let CGSTValue = BillType == "Without GST" ? 0 : (item?.GSTClass && item?.GSTClass != 'Nil') ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.GSTClass / 100)/2 : 0;
                          let SGSTValue = BillType == "Without GST" ? 0 : (item?.GSTClass && item?.GSTClass != 'Nil') ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.GSTClass / 100)/2 : 0;
                          let GSTValue = BillType == "Without GST" ? 0 : (item?.GSTClass && item?.GSTClass != 'Nil') ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.GSTClass / 100) : 0;
                          let DiscountAmount = (item?.Discount && item?.Discount > 0) ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.Discount / 100) : 0;
                          let GrossAmount = item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity;
                          let TotalAmount = GrossAmount + GSTValue - DiscountAmount;
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.ProductName}</td>
                              <td>{item?.ProductQuantity}</td>
                              <td>{item?.ProductEntry ? item?.ProductEntry[0]?.ExpiryDate : 'NA'}</td>
                              <td>{item?.ProductEntry ? item?.ProductEntry[0]?.HSNCode : "NA"}</td>
                              <td>{item?.ProductEntry ? item?.ProductEntry[0]?.BatchNo : "NA"}</td>
                              <td>
                                {item?.MRPAsPerPrimaryPack
                                  ? `Rs. ${item?.MRPAsPerPrimaryPack}`
                                  : '0'}
                              </td>
                              <td>
                                {item?.SellingPriceAsPerPrimaryPack
                                  ? `Rs. ${item?.SellingPriceAsPerPrimaryPack}`
                                  : '0'}
                              </td>
                              <td></td>
                              <td>{`Rs. ${CGSTValue}` } </td>
                              <td>{`Rs. ${SGSTValue}` }</td>
                              <td>{`Rs. ${GSTValue}` }</td>
                              <td>{`Rs. ${GrossAmount}` }</td>
                              <td>{`Rs. ${DiscountAmount}` }</td>
                              <td>{`Rs. ${TotalAmount}` }</td>
                              <td className="deleteCursor">
                                <DeleteIcon onClick={()=> onTapOfDeleteProduct(index)} />
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  )}
                </>
              )}
              {isPreview && (
                <div className="col-md-12">
                  <div className="backButton">
                    <div className="inline__block">
                      <Button
                        onClick={() => editPreview()}
                        color="error"
                        variant="outlined"
                        className="registerEmp__btnRemove"
                      >
                        <EditIcon />
                        &nbsp; {'Edit'}
                      </Button>
                    </div>
                  </div>

                  <table className="table mt-5">
                    <tr>
                      <td>
                        <h5 className="card-events-title product__mainTitle">
                          {userData.storeName}
                        </h5>
                        {
                          <p className="card-events-title">
                            <b>{userData.storeAddress}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            Contact No: <b>{userData.phoneNumber}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            Email Id: <b>{userData.email}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            GST No: <b>{userData.gstNo}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            DL No: <b>{userData.drugLicense}</b>
                          </p>
                        }
                      </td>
                      <td>
                        {previewState.SalesPersonName && (
                          <p className="card-events-title">
                            Sales Person: <b>{previewState.SalesPersonName}</b>
                          </p>
                        )}
                        {previewState.InvoiceNo && (
                          <p className="card-events-title">
                            Invoice No: <b>{previewState.InvoiceNo}</b>
                          </p>
                        )}
                        {previewState.InvoiceDate && (
                          <p className="card-events-title">
                            Invoice Date: <b>{previewState.InvoiceDate}</b>
                          </p>
                        )}
                      </td>
                      <td>
                        {previewState.PartyName && (
                          <p className="card-events-title">
                            Party Name: <b>{previewState.PartyName}</b>
                          </p>
                        )}
                        {previewState.Address && (
                          <p className="card-events-title">
                            Address: <b>{previewState.Address}</b>
                          </p>
                        )}
                        {previewState.Email && (
                          <p className="card-events-title">
                            Email Id: <b>{previewState.Email}</b>
                          </p>
                        )}
                        {previewState.GSTNo && (
                          <p className="card-events-title">
                            GST No: <b>{previewState.GSTNo}</b>
                          </p>
                        )}
                        {previewState.DrugLicense && (
                          <p className="card-events-title">
                            DL No: <b>{previewState.DrugLicense}</b>
                          </p>
                        )}
                      </td>
                    </tr>
                  </table>
                  <table className="table">
                    <thead>
                      <td>S.No</td>
                      <td>Product</td>
                      <td>Quantity</td>
                      <td>Exp Date</td>
                      <td>HSN Code</td>
                      <td>Batch No</td>
                      <td>MRP</td>
                      <td>Selling MRP</td>
                      <td>S/F</td>
                      <td>CGST</td>
                      <td>SGST</td>
                      <td>GST Value</td>
                      <td>Gross Amount</td>
                      <td>Discount</td>
                      <td>Total Amount</td>
                    </thead>
                    <tbody>
                      {previewState &&
                        previewState?.ProductEntry &&
                        previewState?.ProductEntry?.length > 0 &&
                        previewState.ProductEntry.map((item, index) => {
                          let CGSTValue = BillType == "Without GST" ? 0 : (item?.GSTClass && item?.GSTClass != 'Nil') ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.GSTClass / 100)/2 : 0;
                          let SGSTValue = BillType == "Without GST" ? 0 : (item?.GSTClass && item?.GSTClass != 'Nil') ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.GSTClass / 100)/2 : 0;
                          let GSTValue = BillType == "Without GST" ? 0 : (item?.GSTClass && item?.GSTClass != 'Nil') ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.GSTClass / 100) : 0;
                          let DiscountAmount = (item?.Discount && item?.Discount > 0) ? ((item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity) * item?.Discount / 100) : 0;
                          let GrossAmount = item?.SellingPriceAsPerPrimaryPack * item?.ProductQuantity;
                          let TotalAmount = GrossAmount + GSTValue - DiscountAmount;
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.ProductName}</td>
                              <td>{item?.ProductQuantity}</td>
                              <td>{item?.ProductEntry ? item?.ProductEntry[0]?.ExpiryDate : item?.ExpiryDate}</td>
                              <td>{item?.ProductEntry ? item?.ProductEntry[0]?.HSNCode : "NA"}</td>
                              <td>{item?.ProductEntry ? item?.ProductEntry[0]?.BatchNo : "NA"}</td>
                              <td>
                                {item?.MRPAsPerPrimaryPack
                                  ? `Rs. ${item?.MRPAsPerPrimaryPack}`
                                  : '0'}
                              </td>
                              <td>
                                {item?.SellingPriceAsPerPrimaryPack
                                  ? `Rs. ${item?.SellingPriceAsPerPrimaryPack}`
                                  : '0'}
                              </td>
                              <td></td>
                              <td>{`Rs. ${CGSTValue}` } </td>
                              <td>{`Rs. ${SGSTValue}` }</td>
                              <td>{`Rs. ${GSTValue}` }</td>
                              <td>{`Rs. ${GrossAmount}` }</td>
                              <td>{`Rs. ${DiscountAmount}` }</td>
                              <td>{`Rs. ${TotalAmount}` }</td>
                            </tr>
                          )
                        })}
                      <tr>
                        <td colSpan={13}></td>
                        <td>Gross Amount</td>
                        <td>{`Rs. ${calculateGrossAmount()}`}</td>
                      </tr>
                      <tr>
                        <td colSpan={13}></td>
                        <td>GST Value</td>
                        <td>{`Rs. ${calculateGSTAmount()}`}</td>
                      </tr>
                      <tr>
                        <td colSpan={13}></td>
                        <td>Discount</td>
                        <td>{`Rs. ${calculateDiscountAmount()}`}</td>
                      </tr>
                      <tr>
                        <td colSpan={13}></td>
                        <td><b>Total Amount</b> </td>
                        <td>{`Rs. ${calculateTotalAmount()}`}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              <div className="col-sm-12 text-right mt-2">
                <div className="d-flex justify-content-center">
                  {!isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="preview"
                        value="preview"
                        variant="contained"
                        onClick={handlePreviewSubmit}
                        className="registerEmp__btnLogin preview"
                      >
                        {'Preview'}
                      </Button>
                    </div>
                  )}
                  {isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="saved"
                        value="saved"
                        variant="contained"
                        disabled={isLoading ? true : false}
                        onClick={handleSaveSubmit}
                        className="registerEmp__btnLogin save"
                      >
                        {isLoading ? <CircularProgress size={18} /> : 'Save'}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default CreateSalesBills
